import React, {Component} from "react";
import {Table, Icon} from 'antd';
import PropTypes from "prop-types";

const baseUrlPath = "/lcpz/"; //基础路径

/**
 * 流程配置查看表单
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-19 16:05:01
 * Version: 1.0
 * Modify log:
 */
class ViewForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }


    render() {

        const columns = [
            {
                title: '步骤',
                key: 'bz',
                dataIndex: 'bz',
                width: '60px',
            }, {
                title: '环节名称',
                key: 'hjmc',
                dataIndex: 'hjmc',
                width: '110px'
            }, {
                title: '依赖环节',
                key: 'yllchjmc',
                dataIndex: 'yllchjmc',
                width: '110px'
            }, {
                title: '必须办理',
                key: 'hjlb',
                dataIndex: 'hjlb',
                width: '80px',
                render: (text, record) => {
                    const icon = text == '1' ? <Icon type="check-circle" style={{fontSize: 16, color: '#53c41a'}}/>
                        : <Icon type="close-circle" style={{fontSize: 16, color: '#ff4d4f'}}/>

                    return icon;
                },
            }, {
                title: '报到环节',
                key: 'sfbdhj',
                dataIndex: 'sfbdhj',
                width: '80px',
                render: (text, record) => {
                    const icon = text == '1' ? <Icon type="check-circle" style={{fontSize: 16, color: '#53c41a'}}/>
                        : <Icon type="close-circle" style={{fontSize: 16, color: '#ff4d4f'}}/>

                    return icon;
                },
            }, {
                title: '打印报到单',
                key: 'sfdybdd',
                dataIndex: 'sfdybdd',
                width: '80px',
                render: (text, record) => {
                    const icon = text == '1' ? <Icon type="check-circle" style={{fontSize: 16, color: '#53c41a'}}/>
                        : <Icon type="close-circle" style={{fontSize: 16, color: '#ff4d4f'}}/>

                    return icon;
                },
            }, {
                title: '是否启用',
                key: 'zt',
                dataIndex: 'zt',
                width: '60px',
                render: (text, record) => {
                    const icon = text == '1' ? <Icon type="check-circle" style={{fontSize: 16, color: '#53c41a'}}/>
                        : <Icon type="close-circle" style={{fontSize: 16, color: '#ff4d4f'}}/>

                    return icon;
                },
            }
        ];

        const {lcdyVO, lchjVOs} = this.props.initFormData;

        for (let key in lchjVOs) {

            let ylhjVOs = lchjVOs[key].ylhjVOs;
            if (ylhjVOs.length > 0) {
                let lclchjmc = ylhjVOs.map(item => item.yllchjmc);
                lchjVOs[key].yllchjmc = lclchjmc.join('，');
            }
        }

        return (
            <div>
                <Table dataSource={lchjVOs} columns={columns} pagination={false}/>
            </div>
        )
    }
}

ViewForm.propTypes = {
    initFormData: PropTypes.object, //初始数据
}

export default ViewForm;


// WEBPACK FOOTER //
// ./components/lcgl/lcpz/ViewForm.js